// extracted by mini-css-extract-plugin
module.exports = {"container":"no-payment-options_container__3g5fo","title":"no-payment-options_title__1ecyI"};